export default __webpack_public_path__ + "images/b16e37af5355842f8d051f1ea18475ec-x-green.svg";